export enum AdminSuggestionsDataEventObject {
  LIST_SUGGESTIONS = 'list_suggestions',
  APPLY_SUGGESTION = 'apply_suggestion',
}
